import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-localized-table',
  templateUrl: './localized-table.component.html',
  styleUrls: ['./localized-table.component.sass']
})
export class LocalizedTableComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() title: string = 'Localized Values';
  @Input() data: any[] = [];

  ngOnInit() {
    this.data = this.formatData(this.data);
  }

  getColumns(data: any[]): string[] {
    if (data.length === 0) {
      return [];
    }
    return Object.keys(data[0]);
  }

  formatData(data: any[]): any[] {
    const excludedColumns = ['update_trigger', 'glossaryRes', 'start', 'translationRequest', 'verified', 'isLive'];
    if (!Array.isArray(data)) return [];

    return data.map(record => {
      const formatted: Record<string, any> = {};
      for (const key of Object.keys(record)) {
        if (!excludedColumns.includes(key)) {
          formatted[key] = record[key];
        }
      }
      return formatted;
    });
  }
}
